import * as Yup from "yup";
import moment from "moment";

export const periodicAcquirerReportInitialValues = {
  isoID: "",
  currency: "USD",
  reportStartDate: "",
  reportEndDate: "",
};

const today = moment();
const ninetyDaysAgo = moment().subtract(90, "days");
const todayString = today.format("YYYY-MM-DD");
const ninetyDaysAgoString = ninetyDaysAgo.format("YYYY-MM-DD");

const parseDate = (value) => {
  if (!value) return null;
  if (value.match(/^\d{8}$/)) {
    return moment(value, "YYYYMMDD");
  }
  return moment(value);
};

const validateDateRange = (value) => {
  const date = parseDate(value);
  if (!date || !date.isValid()) return false;
  const todayM = moment();
  const ninetyDaysAgoM = moment().subtract(90, "days");
  return date.isBetween(ninetyDaysAgoM, todayM, "day", "[]");
};

export const periodicAcquirerReportValidationSchema = Yup.object().shape({
  isoID: Yup.string(),
  currency: Yup.string().required("Currency is required"),
  reportStartDate: Yup.string()
    .required("Report Start Date is required")
    .test(
      "date-range",
      `Start date must be between ${ninetyDaysAgoString} and ${todayString}`,
      (value) => validateDateRange(value)
    ),
  reportEndDate: Yup.string()
    .required("Report End Date is required")
    .test(
      "date-range",
      `End date must be between ${ninetyDaysAgoString} and ${todayString}`,
      (value) => validateDateRange(value)
    )
    .test(
      "end-after-start",
      "End date must be after or equal to start date",
      function (value) {
        const { reportStartDate } = this.parent;
        if (!value || !reportStartDate) return true;
        const startDate = parseDate(reportStartDate);
        const endDate = parseDate(value);
        if (
          !startDate ||
          !endDate ||
          !startDate.isValid() ||
          !endDate.isValid()
        ) {
          return true;
        }
        return endDate.isSameOrAfter(startDate, "day");
      }
    ),
});
